import { render, staticRenderFns } from "./GbwhatsappUpdate.vue?vue&type=template&id=6067ee92"
import script from "./GbwhatsappUpdate.vue?vue&type=script&lang=js"
export * from "./GbwhatsappUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports